// tslint:disable

import axios from 'axios';
import * as $ from 'jquery';
import { get } from 'lodash';
import * as React from 'react';
import { Environment } from '../../../environment/environment';
import { Field } from '../../libs/form.lib';
import './iri-presenter.scss';

export class IriPresenter extends React.Component<any, any> {
    public state: any = {
        iriValue: null,
        hasError: false,
        isLoading: false,
        isFinished: false
    };

    private iri: string;

    async componentDidMount() {
        this.iri = this.props.iri;

        if (this.props.field) {
            if (this.props.field instanceof Field) {
                this.props.field.onValueChanges$.subscribe((value: any) => {
                    this.iri = get(value, '@id') || this.props.iri || '';
                    this.fetchIri(this.iri);
                });
            }
        }

        if (!this.props.disableEvents) {
            $(this.refs.IRI).on('click', (event: any) => {
                event.preventDefault();
                event.stopPropagation();

                if (!this.props.iri) {
                    return;
                }
                window.open(this.props.iri, '_blank');
            });
        }

        this.fetchIri(this.iri);
    }

    async componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.iri !== this.props.iri) {
            this.iri = this.props.iri;
            this.fetchIri(this.iri);
        }
    }

    public async fetchIri(iri: string) {
        this.setState({
            isLoading: true,
            hasError: false
        });

        try {
            if (!iri) {
                this.setState({
                    iriValue: null,
                    hasError: false,
                    isLoading: false
                });

                return;
            }

            const response = await axios.get(`${Environment.get('api.base')}${iri}`, {withCredentials: true});

            if (!response.data) {
                this.setState({
                    hasError: true,
                    isLoading: false
                });
            }

            if (this.props.path) {
                this.setState({
                    iriValue: get(response.data, this.props.path, '-'),
                    hasError: false,
                    isLoading: false
                });
            } else {
                this.setState({
                    iriValue: response.data,
                    hasError: false,
                    isLoading: false
                });
            }
        } catch (err) {
            this.setState({
                hasError: true,
                isLoading: false
            });
        } finally {
            this.setState({isFinished: true});
        }
    }

    public defaultRender() {
        return (
            <span ref={'IRI'} className="iri-pointer">
                {this.state.isLoading && <i className="fa fa-spin fa-circle-o-notch"/>}
                {(!this.state.isLoading && !this.state.hasError) && (this.state.iriValue || <span>-</span>)}
                {(!this.state.isLoading && this.state.hasError) && <span className="text-danger">(!)</span>}
            </span>
        );
    }

    render() {
        return this.state.isFinished ? (((this.props.render && this.props.render(this.state.iriValue)) || this.defaultRender()) || '' ) : <i className="fa fa-spin fa-circle-o-notch"/>;
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/presenters/iri-presenter.tsx